import { render, staticRenderFns } from "./pr-page-header.vue?vue&type=template&id=5617a052&functional=true&%3Aclass=%5Bdata.class%2C%20data.staticClass%5D"
import script from "./pr-page-header.vue?vue&type=script&lang=ts"
export * from "./pr-page-header.vue?vue&type=script&lang=ts"
import style0 from "./pr-page-header.vue?vue&type=style&index=0&id=5617a052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___ece59b1ed0110506a3a0f8f8739009f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports